<script lang="ts">
  import { fade, scale, slide } from 'svelte/transition'
  import { Search } from '../..'
  import CircleXmarkWhite from './CircleXmarkWhite.svelte'

  const animationSpeed = 300
  let showSearch: boolean = $state(false)
</script>

<div class="search ucBlack-bg" class:search-visible={showSearch}>
  <button class="search-reveal" onclick={()=> showSearch = !showSearch}>
    <p class="text-2xl"><i class="fa-duotone fa-magnifying-glass"></i>Search</p>
    <p class="text-sm"><span>Find members by</span>: Last Name, Keyword & Specialty</p>
    {#if !showSearch}
      <img src="/font-awesome/svgs/solid/chevron-down-white.svg" alt="Arrow pointing down" class="mobile-search-icon" in:fade>
    {/if}
  </button>
  {#if showSearch}
    <div 
      class="mobile-search" 
      in:scale={{delay: 100, duration: animationSpeed,}}
      out:scale={{delay: 0, duration: animationSpeed,}}
    >
      <button
        class="search-close"
        title="Close search"
        onclick={()=> showSearch = false}
        in:scale={{delay: 500}}
      >
        <CircleXmarkWhite class="square-3x3 block" />  
        <span class="sr-only">Close search</span>
      </button>
      <Search mobileMenuPlacement />
    </div>
  {/if}
</div>

<style lang="scss">
  img.mobile-search-icon {
    width: 3rem;
    height: 3rem;
    padding: 0;
    margin: 0.5rem auto;
    overflow: hidden;
    transition: all 0.2s ease-out;
  }
  
  .search {
    position: relative;
    width: 100%;
    border: none;
    margin: 0;
    height: var(--search-height);
    transition: all 0.2s ease-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    
    p {
      color: white;
      margin: 0;
      font-size: 3rem;
      transition: all 0.2s ease-out;

      &.text-2xl {
        padding: 2rem 0 0 0;
      }

      &.text-sm {
        font-size: 1.5rem;
        line-height: 1.5rem;

        > span {
          font-weight: 600;
        }
      }
    }

    &.search-visible {
      cursor: default;
      padding: 0;

      p {
        font-size: 2rem;
        
        &.text-2xl {
          // padding-top: 18px;
        }

        &.text-sm {
          font-size: 1.2rem;
          line-height: 1rem;
        }
      }

      img.mobile-search-icon {
        width: 0;
        height: 0;
      }
    }

    .fa-magnifying-glass { 
      transform: scale(-1, 1);
      margin-right: 1rem;
    }


  }

  .search-reveal {
    background-color: transparent;
    width: 100%;
    border: none;
  }

  button.search-close {
    background: none;
    border: none;
    position: absolute;
    top: 0;
    right: 0;
    // width: 3rem;
    // height: 3rem;
    padding: 1rem;
    margin: 0;
  }
  
  .mobile-search {
    width: 100%;
    height: var(--search-height);
    padding: 1rem;
    opacity: .95;
  }
</style>